import React from 'react';
import { Countdown } from './ui/Countdown';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
const trackInitiateCheckout = (value: number, contentName: string) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'InitiateCheckout', {
      value,
      currency: 'ARS',
      content_name: contentName
    });
  }
};
export function FinalCTA() {
  return <section className="py-10 bg-[#080000]" style={{
    background: 'linear-gradient(to bottom, #dbeafe 0%, #eff6ff 50%, #ffffff 100%)'
  }} data-id="element-61">
      <div className="container mx-auto px-4" data-id="element-62">
        <div className="max-w-4xl mx-auto text-center" data-id="element-63">
          <div className="border-2 border-red-400/50 rounded-2xl p-5 mb-8 inline-block" style={{
          background: 'linear-gradient(135deg, #7f1d1d 0%, #dc2626 50%, #991b1b 100%)'
        }} data-id="element-64">
            <h3 className="text-white font-black uppercase text-xs mb-3" data-id="element-65">
              🔥 EL PRECIO CIERRA EN: 🔥
            </h3>
            <Countdown data-id="element-66" />
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-67">
            <div className="bg-white p-5 rounded-2xl border-2 border-slate-200" data-id="element-68">
              <h4 className="text-base font-black text-black uppercase mb-1.5" data-id="element-69">
                📘 Sistema 12 Semanas
              </h4>
              <div className="text-2xl font-black text-black mb-3" data-id="element-70">$19.999</div>
              <a href="https://tusoluciondigitaloficial.com/cart/43638879551554:1" onClick={() => trackInitiateCheckout(19999, 'Sistema 12 Semanas')} className="block w-full text-center py-2.5 bg-green-500 text-black text-sm font-black uppercase tracking-wider rounded-full border-2 border-black hover:bg-green-600 hover:-translate-y-1 transition-all duration-300" data-id="element-71">
                → QUIERO MI SISTEMA
              </a>
            </div>

            <div className="bg-blue-100 p-5 rounded-2xl border-2 border-blue-600" data-id="element-72">
              <h4 className="text-base font-black text-black uppercase mb-1.5" data-id="element-73">
                🏆 Sistema + Acompañamiento ⭐
              </h4>
              <div className="text-2xl font-black text-black mb-3" data-id="element-74">$29.999</div>
              <a href="https://tusoluciondigitaloficial.com/cart/43653680300098:1" onClick={() => trackInitiateCheckout(29999, 'Sistema + Acompañamiento')} className="block w-full text-center py-2.5 bg-green-500 text-black text-sm font-black uppercase tracking-wider rounded-full border-2 border-black hover:bg-green-600 hover:-translate-y-1 transition-all duration-300" data-id="element-75">
                → QUIERO EL SISTEMA + ACOMPAÑAMIENTO
              </a>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3 text-[10px] font-bold text-white" data-id="element-76">
            <div className="flex items-center gap-1 bg-blue-600 px-2.5 py-1 rounded-full border-2 border-blue-800" data-id="element-77">
              <Lock size={12} data-id="element-78" /> Pago 100% seguro
            </div>
            <div className="flex items-center gap-1 bg-blue-600 px-2.5 py-1 rounded-full border-2 border-blue-800" data-id="element-79">
              <Zap size={12} data-id="element-80" /> Acceso en 5 minutos
            </div>
            <div className="flex items-center gap-1 bg-blue-600 px-2.5 py-1 rounded-full border-2 border-blue-800" data-id="element-81">
              <ShieldCheck size={12} data-id="element-82" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1 bg-blue-600 px-2.5 py-1 rounded-full border-2 border-blue-800" data-id="element-83">
              <CreditCard size={12} data-id="element-84" /> Mercado Pago
            </div>
          </div>
        </div>
      </div>
    </section>;
}